import { render } from "./ScanFolheto.vue?vue&type=template&id=62161128"
import script from "./ScanFolheto.vue?vue&type=script&lang=js"
export * from "./ScanFolheto.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__